<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="8">
          <GradeClassStudentSelect
            :gradeCol="{ cols: 12, md: 6 }"
            :classCol="{ cols: 12, md: 6 }"
            disableStudentSelect
            @changed="gradeClassChange"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            v-model="selectedTeacher"
            clearable
            clear-icon="mdi-close"
            outlined
            label="Giáo viên"
            dense
            deletable-chips
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '../../components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import get from 'lodash-es/get'
export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteTeacherCard
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedTeacher: null
  }),
  computed: {
    classFilter() {
      return { grade: get(this.grade, 'id'), type: 'coreCurriculum' }
    }
  },
  methods: {
    gradeClassChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        grade: get(this.selectedGrade, 'id'),
        id: get(this.selectedClass, 'id'),
        headTeachers: get(this.selectedTeacher, 'id')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
